import { SpacingsValues } from '@picsart/cascade';
import { createUseStyles } from 'react-jss';

import { mediaQuery } from '../../../styles';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ spacing, breakpoints }: ITheme) => ({
    root: {
      marginBottom: 40,
      marginInline: 'auto',
      maxWidth: 'var(--max-width-02)',
      padding: [SpacingsValues.s56, 0],

      [mediaQuery(1480)]: {
        paddingInline: 24,
      },

      [mediaQuery(1096)]: {
        paddingBlock: 40,
        paddingInline: 0,
      },
      [mediaQuery(breakpoints.tablet)]: {
        marginBottom: 0,
      },
    },
    desktop: {
      gap: SpacingsValues.s64,

      [mediaQuery(1096)]: {
        display: 'none',
      },
    },
    title: {
      marginBottom: SpacingsValues.s32,

      [mediaQuery(breakpoints.desktop)]: {
        paddingInline: 24,
        textAlign: 'center',
      },

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: 30,
        marginBottom: SpacingsValues.s24,
        lineHeight: '36px',
        textAlign: 'center',
      },
    },
    label: {
      fontSize: '1.4286rem !important',
      color: 'var(--x-text-color-2) !important',

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: '1.1428rem !important',
      },
    },
    stepsContainer: {
      flex: 1,
      flexDirection: 'column',
      marginLeft: 172,

      [mediaQuery(breakpoints.largeDesktop)]: {
        marginLeft: 0,
      },

      '& > div': {
        cursor: 'pointer',
      },
    },

    steps: {
      flexDirection: 'column',
      gap: SpacingsValues.s8,
    },

    step: {
      flexGrow: 1,
    },

    imageContainer: {
      alignSelf: 'center',
      minWidth: 648,

      '& > img': {
        width: '100%',
        height: '100%',
        objectFit: 'fill',
        pointerEvents: 'none',
      },
    },
    mobile: {
      display: 'none',

      [mediaQuery(1096)]: {
        display: 'block',
      },
    },

    mobileItem: {
      marginTop: spacing.xxLarge,
    },
  }),
  {
    name: 'InteractiveStepsSection',
  },
);

export default useStyles;
